import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router';
import pages from 'common_constants/Pages';
import Logout from 'components_newui/Logout/View';
import { 
  NewLandingPage, 
  IdentityChoose, 
  SignUp, 
  SignUpNew, 
  ResetPassword, 
  ExternalLogin,
  Maintenance   // Added import since it is used below
} from 'pagesNewUi';
import NavigationService from 'support/navigation/NavigationService';
import AzureSSO from 'pagesNewUi/azure_sso/View';

const LoggedOutNavigator = ({ 
  loggedIn, 
  logging, 
  lastDomainVisited, 
  isDomainInMaintenance, 
  shouldGoToMaintenance 
}) => {
  const ROUTES = NavigationService.getRoutes();

  // Determine the default redirect path based on domain maintenance status
  let loggedOutRedirect = lastDomainVisited 
    ? ROUTES[pages.CUSTOM_LOGIN_PAGE].path.replace(':domain', lastDomainVisited) 
    : ROUTES[pages.LANDING_PAGE].path;

  if (isDomainInMaintenance && shouldGoToMaintenance) {
    loggedOutRedirect = ROUTES[pages.MAINTENANCE].path.replace(':domain', lastDomainVisited);
  }

  return (
    <Switch>
      <Route exact path={ROUTES[pages.LANDING_PAGE].path} component={NewLandingPage} />
      <Route exact path={ROUTES[pages.LOGOUT_PAGE].path} component={Logout} />
      <Route exact path="/sso" component={AzureSSO} />
      
      <Route 
        exact 
        path={ROUTES[pages.IDENTITY_CHOOSE_PAGE].path} 
        render={props => logging  ? <IdentityChoose {...props} />  : <Redirect to={ROUTES.login.path} />} 
      />
      
      <Route exact path={ROUTES[pages.LOGIN_PAGE].path} component={ExternalLogin} />
      <Route exact path={ROUTES[pages.RESET_PASSWORD].path} component={ResetPassword} />
      <Route exact path={ROUTES[pages.SIGN_UP].path} component={SignUp} />
      <Route exact path={ROUTES[pages.SIGN_UP_NEW].path} component={SignUpNew} />

      <Route exact path="/static/*" component={Maintenance} />

      {isDomainInMaintenance && (
        <Route exact path={ROUTES[pages.MAINTENANCE].path} component={Maintenance} />
      )}

      {/* Fallback Catch-All Route */}
      <Route render={() => (loggedIn ? <Redirect to={ROUTES.home.path} /> : <Redirect to={loggedOutRedirect} />)} />
    </Switch>
  );
};

LoggedOutNavigator.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  logging: PropTypes.bool.isRequired,
  isDomainInMaintenance: PropTypes.bool.isRequired,
  shouldGoToMaintenance: PropTypes.bool.isRequired,
};

export default LoggedOutNavigator;
